import React, { useEffect, useState } from "react";
import { FallingLines } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "../../components/Hooks/axios";
import styles from "./index.module.scss";

const Poll = ({ setPollShow, postData, forceResults }) => {
	const { userId } = useSelector((state) => state.auth);
	const [pollResult, setPollResult] = useState(false);
	const [pollCalculation, setPollCalculation] = useState(null);
	const [reload, setReload] = useState(0);
	const [isLoading, setIsLoading] = useState(true);
	const [livePostData, setLivePostData] = useState(postData);

	const handelPoll = (vote) => {
		if (!postData?._id) return;
		const raw = JSON.stringify({
			vote,
			userId: userId,
		});

		axios
			.post(`/post/${postData?._id}/Poll`, raw, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then(({ data }) => {
				setPollResult(true);
				setReload(Math.random());
				if (data.message) toast.success("Poll reaction successfully !");
				if (data.error) toast.error(data.error);
			})
			.catch(({ response: { data } }) => {
				setPollResult(true);
				setReload(Math.random());
			});
	};

	useEffect(() => {
		if (!postData?._id) return;
		setIsLoading(true);
		axios
			.get(`/post/${postData?._id}/PollResults`)
			.then(({ data }) => {
				setIsLoading(false);
				setPollResult(data?.isVoted);
				if (data.post) setLivePostData(data.post);
				if (data.error === "Poll results are not visible for this post") setPollCalculation(null);
				else setPollCalculation(data?.pollCalculation);
			})
			.catch(({ response: { data } }) => {
				console.log(data);
			});
	}, [reload]);

	return (
		<div className={styles.PollContainer} onClick={() => setPollShow(false)}>
			<div className={styles.PollSection} onClick={(e) => e.stopPropagation()}>
				{isLoading ? (
					<div className={styles.loaderContainer}>
						<FallingLines color="#3A0DBB" width="100" visible={true} ariaLabel="falling-lines-loading" />
					</div>
				) : (pollResult || forceResults) ? (
					<>
						<h2>Poll Result</h2>
						<div className={styles.ResultList}>
							{livePostData?.customPollEnabled ? (
								livePostData?.customPollData?.map((data, index) => (
									<div key={index} className={styles.ResultItem}>
										<div className={styles.LabelRow}>
											<span>{data}</span>
											<span>{Number(pollCalculation?.[data] || pollCalculation?.[data + "Percentage"] || 0).toFixed(0)}%</span>
										</div>
										<div className={styles.ProgressTrack}>
											<div 
												className={styles.ProgressBar} 
												style={{ width: `${pollCalculation?.[data] || pollCalculation?.[data + "Percentage"] || 0}%` }}
											></div>
										</div>
									</div>
								))
							) : (
								["Yes", "No"].map((label, index) => (
									<div key={index} className={styles.ResultItem}>
										<div className={styles.LabelRow}>
											<span>{label}</span>
											<span>{Number(pollCalculation?.[label.toLowerCase() + "Percentage"] || 0).toFixed(0)}%</span>
										</div>
										<div className={styles.ProgressTrack}>
											<div 
												className={styles.ProgressBar} 
												style={{ width: `${pollCalculation?.[label.toLowerCase() + "Percentage"] || 0}%` }}
											></div>
										</div>
									</div>
								))
							)}
						</div>
					</>
				) : (
					<>
						<h2>Cast Your Vote</h2>
						<div className={styles.VoteList}>
							{livePostData?.customPollEnabled ? (
								livePostData?.customPollData?.map((data, index) => (
									<button key={index} onClick={() => handelPoll(data)}>
										{data}
									</button>
								))
							) : (
								["Yes", "No"].map((label) => (
									<button key={label} onClick={() => handelPoll(label.toLowerCase())}>
										{label}
									</button>
								))
							)}
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default Poll;


